export const PALETTES = {
  // PAC-MAN
  1: [
    '#999106',
    '#635e09',
    '#000000',
    '#e4e4ef'
  ],
  // INKY
  2: [
    '#034f82',
    '#5605a8',
    '#878787',
    '#e4e4ef'
  ],
  // PINKY
  3: [
    '#ed34ac',
    '#5605a8',
    '#878787',
    '#e4e4ef'
  ],
  // BLINKY
  4: [
    '#bf0a0a',
    '#5605a8',
    '#878787',
    '#e4e4ef'
  ]
}